import React from "react";
import { useAppSelector } from "../../hooks/redux";
import { FiltersContainer, FilterButton, Button, DateInput } from "./styles";
import { selectUsers } from "store/reducers/userSlice";

interface Props {
    activeTab: "changes" | "system" | "web_alerts";
    onFilterChange: (
        tab: "changes" | "system" | "web_alerts",
        key: string,
        value: string,
    ) => void;
    filters: {
        changes: {
            robot_id?: string | null;
            group_name: string;
            action: string;
            action_by_id: string;
            ticker: string;
        };
        system: {
            robot_id?: string | null;
            level: string;
            from_date: string;
            to_date: string;
            linked: boolean | undefined;
        };
        web_alerts: {
            robot_id?: string | null;
            level: string;
        };
    };
    onResetFilters: (tab: "changes" | "system" | "web_alerts") => void;
    setPage: React.Dispatch<
        React.SetStateAction<{
            changes: number;
            system: number;
            web_alerts: number;
        }>
    >;
}

const LogFilters: React.FC<Props> = ({
    activeTab,
    onFilterChange,
    filters,
    onResetFilters,
    setPage,
}) => {
    const groups = useAppSelector((state) => state.groups.groups);
    const users = useAppSelector(selectUsers);
    const robots = useAppSelector((state) => state.robots.robots);
    const tickerList = useAppSelector((state) => state.filter.tickerList);
    const actionTypes = [
        "apply_ticker",
        "remove_group",
        "copy_group",
        "change_cp_ticker",
        "change_mdp_ticker",
        "change_sp_ticker",
    ];
    const levels = ["Error", "Warning", "Info"];
    const web_alertsLevels = ["Error", "Success"];
    const handleChange = (key: string, value: string) => {
        onFilterChange(activeTab, key, value);
        setPage({ changes: 1, system: 1, web_alerts: 1 });
    };
    const reset = () => {
        onResetFilters(activeTab);
        setPage((prev) => ({
            ...prev,
            [activeTab]: 1,
        }));
    };
    return (
        <FiltersContainer>
            {activeTab === "changes" && (
                <>
                    <FilterButton
                        value={filters.changes.group_name}
                        onChange={(e) =>
                            handleChange("group_name", e.target.value)
                        }
                    >
                        <option value="">Группа</option>
                        {groups?.map((group) => (
                            <option key={group.id} value={group.name}>
                                {group.name}
                            </option>
                        ))}
                    </FilterButton>

                    <FilterButton
                        value={filters.changes.action}
                        onChange={(e) => handleChange("action", e.target.value)}
                    >
                        <option value="">Тип действий</option>
                        {actionTypes.map((type) => (
                            <option key={type} value={type}>
                                {type}
                            </option>
                        ))}
                    </FilterButton>

                    <FilterButton
                        value={filters.changes.action_by_id}
                        onChange={(e) =>
                            handleChange("action_by_id", e.target.value)
                        }
                    >
                        <option value="">Пользователь</option>
                        {users.map((user) => (
                            <option key={user.id} value={user.id}>
                                {user.username}
                            </option>
                        ))}
                    </FilterButton>
                    <FilterButton
                        value={filters[activeTab].robot_id || ""}
                        onChange={(e) => {
                            const value =
                                e.target.value === "" ? null : e.target.value;
                            handleChange("robot_id", value as any);
                        }}
                    >
                        <option value="">Все роботы</option>
                        {robots.map((robot) => (
                            <option key={robot.robot_id} value={robot.robot_id}>
                                {robot.name} ({robot.robot_id})
                            </option>
                        ))}
                    </FilterButton>
                    <FilterButton
                        value={filters.changes.ticker || ""}
                        onChange={(e) => handleChange("ticker", e.target.value)}
                    >
                        <option value="">Тикер</option>
                        {tickerList?.map((ticker: string) => (
                            <option key={ticker} value={ticker}>
                                {ticker}
                            </option>
                        ))}
                    </FilterButton>
                    <Button onClick={reset}>Сбросить</Button>
                </>
            )}

            {activeTab === "system" && (
                <>
                    <FilterButton
                        value={filters.system.level}
                        onChange={(e) => handleChange("level", e.target.value)}
                    >
                        <option value="">Тип</option>
                        {levels.map((level) => (
                            <option key={level} value={level.toLowerCase()}>
                                {level}
                            </option>
                        ))}
                    </FilterButton>

                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                        }}
                    >
                        <label>От:</label>
                        <DateInput
                            type="date"
                            value={filters.system.from_date}
                            onChange={(e) =>
                                handleChange("from_date", e.target.value)
                            }
                        />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                        }}
                    >
                        <label>До:</label>
                        <DateInput
                            type="date"
                            value={filters.system.to_date}
                            onChange={(e) =>
                                handleChange("to_date", e.target.value)
                            }
                        />
                    </div>
                    <FilterButton
                        value={
                            filters.system.linked === undefined
                                ? ""
                                : filters.system.linked
                                  ? "yes"
                                  : "no"
                        }
                        onChange={(e) => {
                            const value = e.target.value;
                            let parsed: string | boolean | undefined = value;

                            if (value === "") {
                                parsed = undefined;
                            } else if (value === "yes") {
                                parsed = true;
                            } else if (value === "no") {
                                parsed = false;
                            }

                            onFilterChange(activeTab, "linked", parsed as any);
                            // setPage((prev) => ({
                            //     ...prev,
                            //     [activeTab]: 1,
                            // }));
                        }}
                    >
                        <option value="">Все</option>
                        <option value="yes">Связанные вкладки</option>
                        <option value="no">Несвязанные вкладки</option>
                    </FilterButton>
                    <Button onClick={reset}>Сбросить</Button>
                </>
            )}

            {activeTab === "web_alerts" && (
                <>
                    <FilterButton
                        value={filters.web_alerts.level}
                        onChange={(e) => handleChange("level", e.target.value)}
                    >
                        <option value="">Тип</option>
                        {web_alertsLevels.map((level) => (
                            <option key={level} value={level.toLowerCase()}>
                                {level}
                            </option>
                        ))}
                    </FilterButton>
                    <FilterButton
                        value={filters[activeTab].robot_id || ""}
                        onChange={(e) => {
                            const value =
                                e.target.value === "" ? null : e.target.value;
                            handleChange("robot_id", value as any);
                        }}
                    >
                        <option value="">Все роботы</option>
                        {robots.map((robot) => (
                            <option key={robot.robot_id} value={robot.robot_id}>
                                {robot.name} ({robot.robot_id})
                            </option>
                        ))}
                    </FilterButton>
                    <Button onClick={reset}>Сбросить</Button>
                </>
            )}
        </FiltersContainer>
    );
};

export default LogFilters;
